"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogoutButton = void 0;
var react_1 = __importDefault(require("react"));
var recoil_1 = require("recoil");
var login_1 = require("../../hooks/login");
var link_1 = require("../../ui/link");
var userData_1 = require("../../hooks/userData");
var react_router_dom_1 = require("react-router-dom");
function LogoutButton() {
    var navigate = (0, react_router_dom_1.useNavigate)();
    var setLoginState = (0, recoil_1.useSetRecoilState)(login_1.loginState);
    var setUserData = (0, recoil_1.useSetRecoilState)(userData_1.userData);
    var setToken = (0, recoil_1.useSetRecoilState)(login_1.token);
    var userDataValue = (0, recoil_1.useRecoilValue)(userData_1.userData);
    function logout() {
        setLoginState(false);
        setUserData("");
        setToken("");
        navigate("/");
    }
    return (react_1.default.createElement("div", { onClick: logout },
        userDataValue ? react_1.default.createElement("p", null, userDataValue.email) : "",
        react_1.default.createElement(link_1.LinkButton, null, "CERRAR SESION")));
}
exports.LogoutButton = LogoutButton;
